import React from 'react';
import PropTypes from 'prop-types';
import { Stack } from 'office-ui-fabric-react';
import Module from '../../Module';
import ModuleContent from '../../ModuleContent';
import SubModule from '../../SubModule';
import SubModuleHeader from '../../SubModuleHeader';
import { calcFeatureTypes } from '../constants';
import SubModuleContent from '../../SubModuleContent';
import FilterDetails, { calculationFeaturePrefix } from '../../FilterDetails';
import TextButton from '../../TextButton';

const CalculationFeatureCard = ({
  calculationFeature,
  editFeatureClicked,
  hideEditButton = false,
}) => {
  const calcFeature = calcFeatureTypes[calculationFeature.featureType];
  const calcMethod = calcFeature.calculationMethods[calculationFeature.calculationMethod];
  const header = `${calcFeature?.text} by ${calcMethod?.text}`;
  return (
    <Module>
      <ModuleContent>
        <SubModule>
          <SubModuleHeader id={calculationFeature.address} variant="large">
            <span>{header}</span>
          </SubModuleHeader>
          <SubModuleContent>
            <FilterDetails
              filters={calculationFeature.calculations?.map(calc => ({
                ...calc,
                _id: calc.filterId,
              }))}
              prefix={calculationFeaturePrefix(calculationFeature.calculationMethod)}
            />
            {!hideEditButton && (
              <Stack horizontalAlign="end">
                <TextButton onClick={() => editFeatureClicked(calculationFeature)}>
                  Edit Feature
                </TextButton>
              </Stack>
            )}
          </SubModuleContent>
        </SubModule>
      </ModuleContent>
    </Module>
  );
};

CalculationFeatureCard.propTypes = {
  calculationFeature: PropTypes.object.isRequired,
  editFeatureClicked: PropTypes.func,
  hideEditButton: PropTypes.bool,
};

CalculationFeatureCard.defaultProps = {
  editFeatureClicked: () => {},
  hideEditButton: false,
};

export default CalculationFeatureCard;
